import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['price', 'quantity', 'taxRate', 'totalPrice', 'sellPrice', 'sellQuantity', 'sellTotalPrice', 'profit'];

  connect() {
    this.updateTotal();
  }

  updateTotal() {
    this.totalPriceTarget.textContent = this.priceWithCommna(this.totalPrice());

    if (this.hasSellPriceTarget) {
      this.sellTotalPriceTarget.textContent = this.priceWithCommna(this.sellTotalPrice());
      this.profitTarget.textContent = this.priceWithCommna(this.sellTotalPrice() - this.totalPrice());
    }

    event = this.dispatch('updated');
  }

  totalPrice() {
    const price = this.priceTarget.value * this.quantityTarget.value;
    if (this.hasTaxRateTarget) {
      return Math.floor(price * (1 + this.taxRateTarget.value / 100));
    }
    return price;
  }

  sellTotalPrice() {
    return this.sellPriceTarget.value * this.sellQuantityTarget.value;
  }

  priceWithCommna(price) {
    return price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }
}
